import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import moment from 'moment'

import { useAuthentication, useGetAccountRedirectUrl, useInjectCss } from 'src/hooks'
import useGoogleAnalytics from 'src/hooks/common/use-google-analytics.hook'

export const RoutesWrapper = () => {
  const { i18n } = useTranslation()
  const { accountId, simpleProductId } = useParams()
  const navigate = useNavigate()

  const { data, isLoading, isSuccess } = useGetAccountRedirectUrl(
    accountId || null,
    simpleProductId || null,
    i18n.language,
  )

  useEffect(() => {
    if (!isLoading && data) {
      if (data.override_url) {
        window.location.replace(data.override_url)
        return
      }

      if (isSuccess && data?.public === false) {
        // Redirect if account is not public
        navigate('/', { replace: true })
        return
      }
    }

    if (!isLoading && data === null) {
      navigate('/', { replace: true })
    }
  }, [isLoading, data, isSuccess])

  moment.locale(i18n.language)

  useAuthentication()
  useInjectCss()
  useGoogleAnalytics()

  return <Outlet />
}
